import { Controller } from "@hotwired/stimulus"

// Auto-opens the browser print dialog on connect when the server says to.
// Used by customer_orders/ledger_pdf and customer_orders/receipt_pdf.
// window.print() is native -- no jQuery, no teardown needed on disconnect.
export default class extends Controller {
  static values = { autoOpen: Boolean }

  connect() {
    if (this.autoOpenValue) {
      window.print()
    }
  }
}
